import tools from './tools.js' //工具
import dayjs from "dayjs";
const filter = {
	formatTime(time, type = 'YYYY-MM-DD', defa = '') {
		if (!time) return defa;
		let tmp = dayjs(time).format(type);
		return tmp;
	},
	dateFormat(date, fmt) {
		return tools.dateFormat(date, fmt)
	},
	// 字符串截取
	subString(value, length) {
		if (!value) {
			return "";
		}
		value = value.trim();
		if (value.length > length) {
			var first = value.toString().substring(0, length);
			value = first + "...";
		}
		return value;
	}, // 时间处理
	trustTime2(inHisTime) {
		if (!inHisTime) {
			return;
		}
		inHisTime =
			inHisTime = inHisTime.toString().trim().replace(/-/gm, "/");
		var date = null,
			now = new Date();
		if (inHisTime.indexOf("/") != -1) { //yyyy-mm-dd HH:mm:ss
			date = new Date(inHisTime);
		} else {
			date = new Date(Number(inHisTime)); // long 整型
		}
		var year = date.getFullYear(),
			month = date.getMonth() + 1,
			day = date.getDate();
		var monthTime = (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
		if (year === now.getFullYear()) {
			//当年 显示 月-日 时间
			return monthTime;
		} else {
			//不是当年
			return year + "-" + monthTime;
		}
	},
	// 金额格式
	fixedNum(str) {
		if (str) {
			return (1 * str).toFixed(2)
		} else {
			return '0.00'
		}
	},
	// 字符串截取
	timeSub(value, endLength) { //
		if (!value) return;
		return value.substring(0, endLength);
	},
	timeSubstr(value, startLength, endLength) { //
		if (!value) return;
		return value.substring(startLength, endLength);
	},
	// 时间格式转换，将时间内的'-' 转换成 '/'
	transformTime(inHisTime) {
		if (!inHisTime) {
			return;
		}
		inHisTime =
			inHisTime = inHisTime.toString().trim().replace(/-/gm, "/");
		return inHisTime
	},
	/**秒转换为时分秒
	视频时长不超过60s
	00:15
	时长超过60s 小于 1h
	01:25
	15:00
	时长超过1h
	1:32:53
	1:00:01
	1:01:00
	**/
	secondTransTime(value) {
		var secondTime = parseInt(value); // 秒
		var minuteTime = 0; // 分
		var hourTime = 0; // 小时
		if (secondTime >= 60) { //如果秒数大于60，将秒数转换成整数
			//获取分钟，除以60取整数，得到整数分钟
			minuteTime = parseInt(secondTime / 60);
			//获取秒数，秒数取佘，得到整数秒数
			secondTime = parseInt(secondTime % 60);
			//如果分钟大于60，将分钟转换成小时
			if (minuteTime >= 60) {
				//获取小时，获取分钟除以60，得到整数小时
				hourTime = parseInt(minuteTime / 60);
				//获取小时后取佘的分，获取分钟除以60取佘的分
				minuteTime = parseInt(minuteTime % 60);
			}
		}
		var result = "";
		if(secondTime <= 9) secondTime = '0' + secondTime
		if(minuteTime <= 9) minuteTime = '0' + minuteTime
		let val = parseInt(value);
		if (val < 60) {
			result = '00:' + secondTime
		}
		if (val >= 60 && val < 3600) {
			result = minuteTime + ':' + secondTime
		}
		if(val >= 3600){
			result = hourTime + ':' + minuteTime + ':' + secondTime
		}
		return result;
	},
	// 时间处理 当天时分 当年 月日时分 非当年 年月日
	trustTime3(inHisTime) {
		if (!inHisTime) {
			return;
		}
		inHisTime =
			inHisTime = inHisTime.toString().trim().replace(/-/gm, "/");
		var date = null,
			now = new Date();
		if (inHisTime.indexOf("/") != -1) { //yyyy-mm-dd HH:mm:ss
			date = new Date(inHisTime);
		} else {
			date = new Date(Number(inHisTime)); // long 整型
		}
		var year = date.getFullYear(),
			month = date.getMonth() + 1,
			day = date.getDate(),
			hours = date.getHours(),
			minute = date.getMinutes();
		var minuteTime = (hours < 10 ? "0" + hours : hours) + ":" + (minute < 10 ? "0" + minute : minute),
			monthTime = (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
		if (now.toLocaleDateString() === date.toLocaleDateString()) {
			//当天 只显示时间
			return minuteTime;
		} else if (year === now.getFullYear()) {
			//当年 显示 月-日 时间
			return monthTime + " " + minuteTime;
		} else {
			//不是当年
			return year + "-" + monthTime;
		}
	},
  //双录状态
  filterDoubleRecordStatus(num) {
    const m = new Map([
        [-99, '无需双录'],
        [99, '预双录'],
        [0, '待双录'],
        [1, '待审核'],
        [-1, '质检失败'],
        [2, '质检成功'],
        [-2, '待补录'],
        [3, '需重录'],
        [4, '未抽中质检']
    ]);
    return m.get(num);
},
	//证件类型
	filterCardType(num) {
		const m = new Map([
			['01', "身份证"],
			['02', "护照"],
			['03', "军人证"],
			['99', "其它"],
			['06', "户口本"],
			['04', "出生证"],
			['08', "港澳台通行证"],
			['05', "港澳台同胞证"],
			['07', "港澳居民来往内地通行证"],
			['09', "出生证明"],
			['10', "企业三合一证"],
			['11', "组织机构代码"],
			['12', "工商注册号"],
			['13', "统一社会信用代码"],
			['14', "港澳居民居住证"],
			['15', "台湾居民居住证"],
			['16', "台湾居民来往大陆通行证"],
			['17', "港澳台居民居住证"],
			['19', '外国人永久居留身份证'],
		]);
		return m.get(num)||'—'
	},
	//与被保险人关系
	filterRelationShip(num) {
		const m = new Map([
			['1', "本人"],
			['2', "父母"],
			['3', "子女"],
			['4', "配偶"],
			['5', '兄弟姐妹'],
			['30', "孙子女"],
			['31', "外孙子女"],
			['32', "祖父母"],
			['33', "外祖父母"],
			['8', "雇员"],
			['99', "其他"],
		]);
		return m.get(num + '')||'—'
	},
	// 证件类型 过滤
	identifyType(val) {
		var value = "";
		if (!val) return '—';
		val = Number(val);
		switch (val) {
			case 1:
				value = '身份证';
				break;
			case 2:
				value = '护照';
				break;
			case 3:
				value = '军人证';
				break;
			case 4:
				value = '出生证';
				break;
			case 5:
				value = '港澳台同胞证';
				break;
			case 6:
				value = '户口本';
				break;
			case 7:
				value = '港澳居民来往内地通行证';
				break;
			case 8:
				value = '港澳台通行证';
				break;
			case 9:
				value = '出生证明';
				break;
			case 10:
				value = '企业三合一证';
				break;
			case 11:
				value = "组织机构代码"
				break;
			case 12:
				value = "工商注册号"
				break;
			case 13:
				value = "统一社会信用代码"
				break;
			case 14:
				value = "港澳居民居住证"
				break;
			case 15:
				value = "台湾居民居住证"
				break;
			case 16:
				value = "台湾居民来往内地通行证"
				break;
			case 17:
				value = "港澳台居民居住证"
				break;
			case 18:
				value = "外国护照"
				break;
			case 99:
				value = '其它';
				break;
		}
		return value;
	},
  // 回执状态
  filterReturnStatus(val){
    if (!val) {
      return '-';
    }
    const map = {
        '0': '待回执',
        '1': '回执成功',
        '2': '回执失败',
        '3': '回执审核中',
        '-1': '无需回执'
    };
    return map[val] || '-';
  },
  // 回访状态
  filterVisitStatus(val){
    if (!val) {
      return '-';
    }
    const map = {
        '0': '待回访',
        '1': '回访成功',
        '2': '回访失败',
        '3': '无需回访',
        '-2': '回访审核中',
    };
    return map[val] || '-';
  },
  //保单状态
  policyStatus(value) {
    if (value == '0') {
        return '待付款';
    } else if (value == '1') {
        return '保障中';
    } else if (value == '-1') {
        return '已失效';
    } else if (value == '-2') {
        return '核保中';
    } else if (value == '3') {
        return '待审核';
    } else if (value == '-3') {
        return '核保失败';
    } else if (value == '4') {
        return '扣款成功';
    } else if (value == '-4') {
        return '扣款失败';
    } else if (value == '-6') {
        return '已退保';
    } else if (value == '-7') {
        return '已终止';
    } else if (value == '99') {
        return '人工核保';
    }
  },
  // 回执回访状态
  filterReturnVisitStatus1(val) {
    if (!val) {
        return '-';
    }
    const map = {
        '-1': '无需回执回访',
        '0': '待回执',
        '1': '回执失败',
        '2': '待回访',
        '3': '回访失败',
        '4': '审核中',
        '5': '回执回访成功'
    };
    return map[val] || '-';
}
}

export default filter
